export const GET_MSG_LIST = 'GET_MSG_LIST'
export const SET_MSG_LIST = 'SET_MSG_LIST'

export const GET_UNREAD_MSG_LIST = 'GET_UNREAD_MSG_LIST'
export const SET_UNREAD_MSG_LIST = 'SET_UNREAD_MSG_LIST'

export const SET_MSG_READ = 'SET_MSG_READ'

export const DELETE_MSG = 'DELETE_MSG'

export const SELECT_MSG_ITEM = 'SELECT_MSG_ITEM'
export const REFRESH_MSG_LIST = 'REFRESH_MSG_LIST'
export const REFRESH_UNREAD_MSG_LIST = 'REFRESH_UNREAD_MSG_LIST'
